import { Helmet } from 'react-helmet';
import React from 'react';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import { shallow } from '@jwp/ott-common/src/utils/compare';
import env from '@jwp/ott-common/src/env';
import { getI18n } from 'react-i18next';
import { useLocation, type Location } from 'react-router';
import { createURL } from '@jwp/ott-common/src/utils/urlFormatting';

const generateAlternateLinks = (location: Location) => {
  const publicUrl = env.APP_PUBLIC_URL;
  const supportedLanguages = getI18n().options.supportedLngs;

  if (!publicUrl || !Array.isArray(supportedLanguages) || location.pathname !== '/') return [];

  return supportedLanguages
    .filter((language) => language !== 'cimode')
    .map((language) => ({
      lang: language,
      href: createURL(`${env.APP_PUBLIC_URL}${location.pathname}`, { lng: language }),
    }));
};

const SiteMetadata = () => {
  const { siteName, description } = useConfigStore(({ config }) => config, shallow);
  const location = useLocation();

  return (
    <Helmet>
      <title>{siteName}</title>
      <meta name="description" content={description} />
      <meta property="og:description" content={description} />
      <meta property="og:title" content={siteName} />
      <meta name="twitter:title" content={siteName} />
      <meta name="twitter:description" content={description} />
      {generateAlternateLinks(location).map(({ lang, href }) => (
        <link rel="alternate" hrefLang={lang} href={href} key={lang} />
      ))}
    </Helmet>
  );
};

export default SiteMetadata;
